import React, { Component } from 'react';
import InView from '../../containers/SectionWrapper.jsx'
import { getRandom } from '../../utils/numbers.js'

import './Brands.css'
import { upperCase } from 'lodash';

class Brands extends Component {

    render() {

        const { brands } = this.props

        return (


            <section className="ptlg pblg xs-ptsm xs-pbsm">

                <div className="grid">

                    <div className="unit whole">

                        <InView>

                            <div className="brands text-center">
{/* 
                                <div className="hr-container">
                                    <hr className="left" />
                                </div> */}

                                <h2 className="mb5" style={{ textTransform: 'uppercase', letterSpacing: '18px'}}>Brands</h2>

                                <p className="mb50">
                                    Some of the brands i've worked with
                            </p>

                                <div>

                                    {brands.map((brand, index) => {

                                        const delay = getRandom(5, 10) / 10;

                                        return <div key={index} className="brand" style={{ transitionDelay: `${delay}s`, fontSize: `${delay * 2}em` }}>
                                            {brand}
                                        </div>

                                    })}

                                </div>

                            </div>
                        </InView>

                    </div>
                </div>

            </section>

        );
    }
}

export default Brands;